import { container } from "tsyringe";
import { ProfitCenterClient } from "./profitCenterClient";
import "reflect-metadata";

export class ProfitCentersService {
	private readonly profitCentersClient: ProfitCenterClient =
		container.resolve(ProfitCenterClient);

	public async getProfitCenters() {
		return await this.profitCentersClient.profitCentersApi.profitCentersControllerGetProfitCenters();
	}
}
